export const DREAM_BIG = 'DREAM_BIG';
export const GAME_CHANGER = 'GAME_CHANGER';
export const EXTRA_MILE = 'EXTRA_MILE';
export const CARD_4 = 'CARD_4';
export const CARD_5 = 'CARD_5';
export const CARD_6 = 'CARD_6';
export const CARD_7 = 'CARD_7';
export const CARD_8 = 'CARD_8';
export const CARD_9 = 'CARD_9';
export const CARD_10 = 'CARD_10';
export const CARD_11 = 'CARD_11';
export const CARD_12 = 'CARD_12';
export const CARD_13 = 'CARD_13';
export const CARD_14 = 'CARD_14';
export const CARD_15 = 'CARD_15';
export const CARD_16 = 'CARD_16';
export const CARD_17 = 'CARD_17';
export const CARD_18 = 'CARD_18';
export const CARD_19 = 'CARD_19';
export const CARD_20 = 'CARD_20';
